<template>
  <batch-upload-file lob="SI" />
</template>

<script>
import batchUploadFile from '@/components/Cargo/FileUpload/batchUploadFile'
export default {
  name: 'SIBatchUploadFile',
  components: { batchUploadFile }
}
</script>

<style scoped>

</style>
